module.exports = {"TXTWCL_Need_helpX":{"id":"TXTWCL_Need_helpX","defaultMessage":"Precisa de ajuda?","flags":["TRACK"],"track":"Need help?"}}